import { render, staticRenderFns } from "./g-search.vue?vue&type=template&id=f8adc16e&scoped=true"
import script from "./g-search.vue?vue&type=script&lang=js"
export * from "./g-search.vue?vue&type=script&lang=js"
import style0 from "./g-search.vue?vue&type=style&index=0&id=f8adc16e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8adc16e",
  null
  
)

export default component.exports